module.exports = __webpack_public_path__ + "img/4.c6875a85.webp";